import React from 'react';
import ServerList from './components/ServerList';
import PropTypes from 'prop-types';

import { Header, useModal, Onboarding, toast } from '@ohif/ui-next';
import { SidebarNavigation } from '@ohif/ui';
import { Types as coreTypes } from '@ohif/core';
import { useAppConfig } from '@state';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
function AdminServer({ servicesManager }) {
  const { t } = useTranslation();
  const { show } = useModal();
  const navigate = useNavigate();
  const [appConfig] = useAppConfig();

  const { menuOptions } = getHeaderConfig({
    servicesManager,
    t,
    show,
    navigate,
    appConfig,
  });
  return (
    <div>
      <Header
        isSticky
        menuOptions={menuOptions}
        isReturnEnabled={false}
        WhiteLabeling={appConfig.whiteLabeling}
      />
      <Onboarding />
      <SidebarNavigation onFilterToggle={() => navigate('/')} />
      <div className="container mx-auto min-h-screen bg-gray-50 pt-5 text-white max-sm:p-4 sm:pl-9">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-white">Conexiones DICOM</h1>
            <p className="mt-2 text-lg text-white">
              Gestión de conexiones DICOM para la comunicación con servidores de imágenes médicas.
            </p>
          </div>
        </div>

        <ServerList />
      </div>
    </div>
  );
}
export function getHeaderConfig({ servicesManager, t, show, navigate, appConfig }) {
  const { customizationService } = servicesManager.services;

  const AboutModal = customizationService.getCustomization(
    'ohif.aboutModal'
  ) as coreTypes.MenuComponentCustomization;
  const UserPreferencesModal = customizationService.getCustomization(
    'ohif.userPreferencesModal'
  ) as coreTypes.MenuComponentCustomization;

  const menuOptions = [
    {
      title: AboutModal?.menuTitle ?? t('Header:About'),
      icon: 'info',
      onClick: () =>
        show({
          content: AboutModal,
          title: AboutModal?.title ?? t('AboutModal:About MED VIEWER'),
          containerClassName: AboutModal?.containerClassName ?? 'max-w-md',
        }),
    },
    {
      title: UserPreferencesModal?.menuTitle ?? t('Header:Preferences'),
      icon: 'settings',
      onClick: () =>
        show({
          content: UserPreferencesModal,
          title: UserPreferencesModal?.title ?? t('UserPreferencesModal:User preferences'),
          containerClassName:
            UserPreferencesModal?.containerClassName ?? 'flex max-w-4xl p-6 flex-col',
        }),
    },
  ];

  if (appConfig.oidc) {
    menuOptions.push({
      icon: 'power-off',
      title: t('Header:Logout'),
      onClick: () => {
        navigate(`/logout?redirect_uri=${encodeURIComponent(window.location.href)}`);
      },
    });
  }

  return { menuOptions, appConfig };
}

AdminServer.propTypes = {
  isLoadingData: PropTypes.bool,
  servicesManager: PropTypes.object.isRequired,
};
export default AdminServer;
